import React, { useEffect, useState } from 'react';
import '../CSS/Home.css';
import HomeReportsGrid from '../Components/HomeReportGrid.js';
import HomeHighlights from '../Components/HomeHighlights.js';
import Banner from '../Components/Banner.js';
import useIsMobile from '../Components/UseIsMobile.js';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

const Home = () => {
  const isMobile = useIsMobile();

  const [showRecentReports, setShowRecentReports] = useState(!isMobile);
  const [showFeaturedInsights, setShowFeaturedInsights] = useState(!isMobile);
  const [homePhotos, setHomePhotos] = useState([]);
  const [selectedPhoto, setSelectedPhoto] = useState(null);

  useEffect(() => {
    fetch('/api/org-photos/HOME-PAGE', {
      credentials: 'include',
      cache: 'no-store',
    })
      .then((res) => res.json())
      .then((data) => {
        const sortedPhotos = [...(data.photos || [])].sort((a, b) =>
          (a.name || '').localeCompare(b.name || '')
        );

        setHomePhotos(sortedPhotos);
      })
      .catch((err) => {
        console.error('Error loading homepage photos:', err);
        setHomePhotos([]);
      });
  }, []);

  return (
    <div>
      <Banner />

      <div className="home-swiper-section">
        {homePhotos.length === 0 ? (
          <div className="home-swiper-empty">
            No HOME-PAGE images found.
          </div>
        ) : (
          <Swiper
            key={`home-swiper-${homePhotos.length}`}
            className="home-swiper"
            modules={[Autoplay, Pagination, Navigation]}
            grabCursor={true}
            centeredSlides={true}
            slidesPerView={isMobile ? 1 : 2.15}
            spaceBetween={30}
            loop={homePhotos.length > 2}
            initialSlide={homePhotos.length > 1 ? homePhotos.length - 1 : 0}
            speed={450}
            observer={true}
            observeParents={true}
            autoplay={{
              delay: 6000,
              disableOnInteraction: false,
              pauseOnMouseEnter: false,
              waitForTransition: false,
            }}
             onSwiper={(swiper) => {
    setTimeout(() => {
      swiper.autoplay.start();
    }, 500);
  }}
            pagination={{ clickable: true }}
            navigation={!isMobile}
          >
            {homePhotos.map((photo, index) => (
              <SwiperSlide key={photo.id || photo.name || index}>
                <div className="home-slide">
                  <img
                    src={photo.proxyUrl}
                    alt={photo.name || `Home slide ${index + 1}`}
                    onClick={() => setSelectedPhoto(photo)}
                    onError={() => console.error('Image failed to load:', photo)}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>

      {selectedPhoto && (
        <div className="photo-modal-overlay" onClick={() => setSelectedPhoto(null)}>
          <div className="photo-modal-content" onClick={(e) => e.stopPropagation()}>
            <button
              className="photo-modal-close"
              onClick={() => setSelectedPhoto(null)}
            >
              ×
            </button>

            <img
              src={selectedPhoto.proxyUrl}
              alt={selectedPhoto.name}
              className="photo-modal-image"
            />

            <p className="photo-modal-caption">{selectedPhoto.name}</p>
          </div>
        </div>
      )}

      {!isMobile && (
        <div className="columns">
          <div className="column">
            <h2>Recent Reports</h2>
            <HomeReportsGrid />
          </div>

          <div className="column">
            <h2>Featured Insights</h2>
            <HomeHighlights />
          </div>
        </div>
      )}

      {isMobile && (
        <div className="columns">
          <div className="column">
            <h2
              className="collapsible-title"
              onClick={() => setShowRecentReports(!showRecentReports)}
            >
              Recent Reports {showRecentReports ? '▼' : '▶'}
            </h2>

            <div className={`collapsible-content ${showRecentReports ? 'open' : ''}`}>
              <HomeReportsGrid />
            </div>
          </div>

          <div className="column">
            <h2
              className="collapsible-title"
              onClick={() => setShowFeaturedInsights(!showFeaturedInsights)}
            >
              Featured Insights {showFeaturedInsights ? '▼' : '▶'}
            </h2>

            <div className={`collapsible-content ${showFeaturedInsights ? 'open' : ''}`}>
              <HomeHighlights />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;